import { render, staticRenderFns } from "./change_logs.vue?vue&type=template&id=2f760876"
import script from "./change_logs.vue?vue&type=script&lang=js"
export * from "./change_logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports